import { Text, Tooltip } from "@mantine/core";

// Interim presentation for an id with no resolvable name (e.g. cross-tenant
// end-customer business ids — there is no business-name-by-ids endpoint yet):
// a tidy monospace short-id chip with the full id in a tooltip, instead of a
// bare UUID. Read-only.
export function ShortId({ id }: { id: string | null | undefined }) {
  if (!id) return <Text size="sm" c="dimmed">—</Text>;
  return (
    <Tooltip label={id} withArrow>
      <Text size="sm" c="dimmed" ff="monospace" style={{ cursor: "default" }}>{id.slice(0, 8)}…</Text>
    </Tooltip>
  );
}
